import { render } from "./BaseAlert.vue?vue&type=template&id=4589d084&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"

import "./BaseAlert.vue?vue&type=style&index=0&id=4589d084&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4589d084"]])

export default __exports__